import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { createContext, useContext } from "react";

const fetchConfig = async () => {
  const res = await axios.get(`${process.env.REACT_APP_API_URL}config`);
  return res.data.data[0];
};

const fetchProductTypes = async () => {
  const res = await axios.get(
    `${process.env.REACT_APP_API_URL}productCategory`,
  );
  return res.data.data;
};

const fetchTreatmentTypes = async () => {
  const res = await axios.get(`${process.env.REACT_APP_API_URL}treatments`);
  return res.data.data;
};

const ConfigContext = createContext();
export const useConfig = () => useContext(ConfigContext);

export const ConfigProvider = ({ children }) => {
  const configQuery = useQuery({
    queryKey: ["config"],
    queryFn: fetchConfig,
    staleTime: 1000 * 60 * 60 * 24,
  });

  const productTypeQuery = useQuery({
    queryKey: ["product-types"],
    queryFn: fetchProductTypes,
    staleTime: 1000 * 60 * 60 * 24,
  });

  const treatmentTypeQuery = useQuery({
    queryKey: ["treatment-types"],
    queryFn: fetchTreatmentTypes,
    staleTime: 1000 * 60 * 60 * 24,
  });

  return (
    <ConfigContext.Provider
      value={{
        configData: configQuery?.data ? configQuery.data : [],
        productTypeData: productTypeQuery?.data ? productTypeQuery.data : [],
        treatmentTypeData: treatmentTypeQuery?.data ? treatmentTypeQuery.data : [],
        isLoading:
          configQuery.isLoading ||
          productTypeQuery.isLoading ||
          treatmentTypeQuery.isLoading,
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
};
